<template>
  <div>
    <VueFileAgent
       ref="fileAgent"
      :multiple="true"
      :deletable="true"
      :meta="true"
      :accept="'video/*'"
      :maxSize="'400MB'"
      :maxFiles="1"
      :helpText="selectText"
      :readonly="isReadOnly"
      :errorText="{
        type:errorMessage,
        size: errorSize,
      }"
      :thumbnailSize="120"
      :theme="'list'"
       v-model="fileRecords"
       @select="filesSelected($event)"
       @beforedelete="onBeforeDelete($event)"
       @delete="onDelete($event)"
    ></VueFileAgent>
    <k-progress type="line" :percent="percentCnt" ></k-progress>
  </div>
</template>
<script>
import Axios from 'axios'

export default {
    // ...
    data: function(){
      return {
          fileRecords: []
        , detail : {}
        , selectText :  "파일을 선택해주세요"
        , errorMessage : "이 형식은 비디오형식이 아닙니다."
        , errorSize : "사이즈가 400MB가 넘습니다."
        , cnt : 0
        , isReadOnly : false
        , detailOption:''
        , option:''
        , percentCnt : 0
      };
    }
    , props:['listvideofile']
    , mounted:function(){
    }
    , watch:{
       listvideofile:function(newVal, oldVal){
           let vm = this;
           if(newVal.length > 0){
             for(let i=0; i< newVal.length; i++){
                this.fileRecords.push(this.setFileRemindFromDB(newVal[i]));
                vm.cnt++;
             }
           }
       }
       , detailOption:function(newVal){
           let vm = this;
           vm.option = newVal;
       }
    }
    , methods:{
          selectDurTime:function(evt){
             let vm = this;
             vm.detailOption = evt;

          },
          filesSelected(evt){

             let vm = this;

             if(evt.length == 0){

             }else{

                 for(let i=0; i<evt.length; i++){
                      if(evt[i].file.type.indexOf('video') > -1){
                        vm.cnt++;
                        vm.getUploadFiles(evt[i], vm.cnt);
                     }else{
                        continue;
                     }
                 }
               }

          }

         , onBeforeDelete(fileRecord){
            let vm = this;

            if(confirm('삭제하시겠습니까?')){
               if(fileRecord.file == null){
                  let _inner = $("#fileKey").val();
                  let _key = $("#fileKey").val();
                  for(let i=0; i<this.fileRecords.length; i++){
                     if(this.fileRecords[i].filePath === fileRecord.filePath){
                        let _path = fileRecord.filePath.split("/");
                        let _cnt = i+1;
                        vm.getDelete(_cnt, _path[3], "new", fileRecord.fileKey);
                     }
                  }
               }else{
                  if(fileRecord.file.type.indexOf('video') > -1){
                     for(let i=0; i<this.fileRecords.length; i++){
                        if(this.fileRecords[i].file.name === fileRecord.file.name){
                           let _cnt = i+1;
                           vm.getDelete(_cnt, fileRecord.file.name, "org");
                        }
                     }
                  }
               }
               this.$refs.fileAgent.deleteFileRecord(fileRecord);
               vm.$parent.videoRes = {}; // 하단 문구 초기화
            }
        }
        ,getDelete(_cnt, _name, type, fileKey){

             let vm = this;
             let _form = new FormData();
             let _inner = (fileKey != null) ? fileKey : $("#fileKey").val();
             let _key = $("#fileKey").val();
             let usrKey = $("#usrKey").val();
             _form.append('paramUid', usrKey);
             _form.append('paramText', _name);
             _form.append('resultData', _cnt);
             _form.append('defaultView', _inner);
             _form.append('statusCode', type);

            Axios.post("/api/video/delete", _form, { headers: { 'Content-Type': 'multipart/form-data' }
            }).then(function(response) {
               vm.cnt--;
            }).catch(function(ex) {
               console.log(ex);
            });
        }
        ,setFileRemindFromFile(_data, time){
           return  {
              name : _data.file.name,
              sizeText :_data.sizeText,
              size : _data.size,
              type : _data.type,
              ext : _data.ext,
              width : _data.dimensions.width,
              height : _data.dimensions.height,
              color : _data.color,
              durTime: (time == null) ? null :time.durTime,
              setTime: (time == null) ? null :time.setTime,

           };
        }
        ,setFileRemindFromDB(_data){
           return  {
              name : _data.file_org_name,
              sizeText :_data.sizeText,
              size : _data.size,
              type : _data.filetype,
              ext : _data.fileExt,
              filePath: '/video/' + _data.file_new_name.substring(0,8) + "/" + _data.file_new_name,
            //   url: "http://localhost:8080/video/" + _data.file_new_name.substring(0,8) + "/" + _data.file_new_name,
              url: "/video/" + _data.file_new_name.substring(0,8) + "/" + _data.file_new_name,
              fileKey: _data.cmm_sprt,
              //urlResized: _data.imgBase64,
              lastModified: 1583992794341
           };
        }
        ,getUploadFiles(evt, cnt){
             let vm = this;
             let _inner = $("#fileKey").val();
             let _key = $("#fileKey").val();
             let _form = new FormData();
             let _detailOption = (vm.$parent.detailOption == null || vm.$parent.detailOption == undefined) ? null : vm.$parent.detailOption;
             let _data = vm.setFileRemindFromFile(evt, _detailOption);
             let _param = _data;

             _form.append('uploadFiles', evt.file);
             _form.append('paramText', _key);
             _form.append('resultData', vm.cnt);
             _form.append('defaultView', _inner);
             _form.append('paramOption', JSON.stringify(_param) );

            if(typeof(vm.$parent.videoRes) != undefined ){
               vm.$parent.videoRes = {resValue:"ready",resText:"업로드 중..."};
            }

            for (var i=0; i<this.fileRecords.length; i++) {
               console.log(vm.fileRecords[i].error);

               if(vm.fileRecords[i].error.size) {
                  vm.$parent.videoRes = {resValue:"fail"};
                  vm.percentCnt = 0;
                  return;
               }
               if(vm.fileRecords[i].error.type) {
                  vm.$parent.videoRes = {resValue:"fail"};
                  vm.percentCnt = 0;
                  return;
               }
            }

            const config = {
                headers: { 'Content-Type': 'multipart/form-data' } ,
                onUploadProgress : (progressEvent) => {
                     vm.percentCnt = Math.round( (progressEvent.loaded * 95) / progressEvent.total );
                }
            }

              Axios.post("/api/video/upload", _form, config).then(function(response) {
                  if(typeof(vm.$parent.videoRes) != undefined ){
                     if(response.data.result == null){
                        vm.$parent.videoRes = {resValue:"fail",resText:"업로드 실패 - 지원하지 않는 형식입니다. avi 확장자로 변환한 뒤 다시 시도해주세요."};
                        vm.percentCnt = 0;
                     }else{
                        console.log("response.data.result",response.data.result);
                        //시작시간 오류
                        if(response.data.result == "err_durTime"){
                           vm.$parent.videoRes = {resValue:"fail",resText:"업로드 실패 - 영상의 총 길이보다 시작시간이 큽니다."};
                           vm.percentCnt = 0;
                        }else{
                           vm.$parent.videoRes = {resValue:"succ",resText:"업로드 성공"};
                           vm.percentCnt = 100;
                        }
                     }

                     //vm.$parent.videoRes = (response.data.result == null) ? {resValue:"fail",resText:"업로드 실패"} : {resValue:"succ",resText:"업로드 성공"};
                     //vm.percentCnt = (response.data.result == null) ? 0 : 100;
                  }
              }).catch(function(ex) {
                 console.log(ex);
                 vm.$parent.videoRes = {resValue:"fail",resText:"업로드 실패"}
                 vm.percentCnt = 0;
              });
        }
        , onDelete(evt){
         }
    }
  }
</script>
